export default __webpack_public_path__ + "static/media/warning-icon.03ea4e4f.svg";